import styled from 'styled-components';

/* ----------------------------------
   Overview
----------------------------------- */

export const AuditOverview = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.85fr);
  gap: var(--space-xxxl);

  align-items: center;

  @media screen and (max-width: 1100px) {
    grid-template-columns: 1fr;
    gap: var(--space-xxl);
  }
`;

export const OverviewContent = styled.div`
  max-width: 720px;
`;

export const OverviewTitle = styled.h2`
  margin: var(--space-xs) 0 var(--space-l);

  color: var(--grey7);

  font-size: clamp(2rem, 4vw, 3.25rem);
  line-height: 1.05;
  font-weight: 900;
  letter-spacing: -0.035em;
`;

export const OverviewText = styled.p`
  margin: 0 0 var(--space-m);

  color: var(--grey4);

  font-size: 1rem;
  line-height: 1.8;
  font-weight: 500;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const OverviewActions = styled.div`
  margin-top: var(--space-xl);

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-s);

  @media screen and (max-width: 500px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

/* ----------------------------------
   Audit panel
----------------------------------- */

export const AuditPanel = styled.div`
  width: 100%;

  padding: var(--space-xl);

  border: 1px solid var(--grey15);
  border-radius: var(--borderRadiusLarge);

  background: var(--cardBackground);

  box-shadow: var(--shadow-md);
`;

export const PanelHeader = styled.div`
  margin-bottom: var(--space-xl);
  padding-bottom: var(--space-m);

  border-bottom: 1px solid var(--grey);

  h3 {
    margin: var(--space-xxs) 0 0;

    color: var(--grey7);

    font-size: 1.45rem;
    line-height: 1.2;
    font-weight: 900;
  }
`;

export const PanelEyebrow = styled.span`
  color: var(--orange5);

  font-size: 0.7rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.12em;
`;

export const AuditStatusList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AuditStatusItem = styled.div`
  padding: var(--space-m) 0;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: var(--space-m);

  align-items: flex-start;

  &:not(:last-child) {
    border-bottom: 1px solid var(--grey);
  }

  strong {
    display: block;

    margin-bottom: var(--space-xxs);

    color: var(--grey7);

    font-size: 0.95rem;
    font-weight: 900;
  }

  span {
    display: block;

    color: var(--grey4);

    font-size: 0.85rem;
    line-height: 1.55;
  }
`;

export const StatusIcon = styled.div`
  width: 40px;
  height: 40px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  border-radius: 50%;

  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);

  color: var(--orange5);

  box-shadow: inset 0 0 0 1px rgba(230, 139, 7, 0.12);
`;
